import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

// Pages
import Ruleta from "./pages/Ruleta";
import RuletaGate from "./pages/RuletaGate";
import Tienda from "./pages/Tienda";
import ConfirmarCompra from "./pages/ConfirmarCompra";
import MisPremios from "./pages/MisPremios";
import AdminPremios from "./pages/AdminPremios";
import AdminSegmentModals from "./pages/AdminSegmentModals";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<RuletaGate />} />
            <Route path="/tienda" element={<Tienda />} />
            <Route path="/confirmar-compra" element={<ConfirmarCompra />} />
            <Route path="/mis-premios" element={<MisPremios />} />
            <Route path="/admin/premios" element={<AdminPremios />} />
            <Route path="/admin/segmentos" element={<AdminSegmentModals />} />
            {/* Redirect old HTML routes to new React routes */}
            <Route path="/ruleta-fintech.html" element={<Navigate to="/" replace />} />
            <Route path="/tienda-tiquetes.html" element={<Navigate to="/tienda" replace />} />
            <Route path="/my-rewards.html" element={<Navigate to="/mis-premios" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
